module.exports = __webpack_public_path__ + "static/media/img2.34555d31.png";